import React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { Button, Modal, Portal, Text, TextInput } from 'react-native-paper';
import { colors, spacing, typography } from '../../../constants/theme';
import { TemplateForm, TemplateModalMode } from '../AdminDashboard.types';

interface AdminTemplateModalProps {
  visible: boolean;
  mode: TemplateModalMode;
  form: TemplateForm;
  onChangeForm: (form: TemplateForm) => void;
  onDismiss: () => void;
  onSubmit: () => void;
}

export const AdminTemplateModal: React.FC<AdminTemplateModalProps> = ({
  visible,
  mode,
  form,
  onChangeForm,
  onDismiss,
  onSubmit,
}) => (
  <Portal>
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      contentContainerStyle={styles.modal}
    >
      <ScrollView>
        <Text style={styles.modalTitle}>
          {mode === 'create' ? 'Create New Template' : 
           mode === 'edit' ? 'Edit Template' : 
           'Clone Template'}
        </Text>

        <TextInput
          label="Template Name"
          value={form.name}
          onChangeText={(text) => onChangeForm({ ...form, name: text })}
          style={styles.formField}
        />

        {mode !== 'edit' && (
          <TextInput
            label="Template Type"
            value={form.type}
            onChangeText={(text) => onChangeForm({ ...form, type: text })}
            style={styles.formField}
            placeholder="e.g., custom_review"
          />
        )}

        <TextInput
          label="Description (Optional)"
          value={form.description}
          onChangeText={(text) => onChangeForm({ ...form, description: text })}
          style={styles.formField}
          multiline
        />

        <View style={styles.formRow}>
          <Button
            mode="outlined"
            onPress={onDismiss}
            style={styles.formField}
          >
            Cancel
          </Button>
          <Button
            mode="contained"
            onPress={onSubmit}
            style={styles.formField}
          >
            {mode === 'create' ? 'Create' : 
             mode === 'edit' ? 'Update' : 
             'Clone'}
          </Button>
        </View>
      </ScrollView>
    </Modal>
  </Portal>
);

const styles = StyleSheet.create({
  modal: {
    backgroundColor: colors.background,
    margin: spacing.lg,
    padding: spacing.lg,
    borderRadius: 8,
    maxHeight: '90%',
    minHeight: '70%',
  },
  modalTitle: {
    ...typography.h2,
    marginBottom: spacing.lg,
  },
  formRow: {
    flexDirection: 'row',
    gap: spacing.sm,
    marginTop: spacing.lg,
  },
  formField: {
    flex: 1,
    marginBottom: spacing.md,
    backgroundColor: colors.surface,
    borderWidth: 1,
    borderColor: colors.border,
    borderRadius: 4,
    paddingHorizontal: spacing.sm,
  },
});

export default AdminTemplateModal;
